import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["href", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { useTheme } from 'styled-components';
import { IconButton, Logo } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var HeaderLogoBase = function HeaderLogoBase(_ref) {
  var href = _ref.href,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var _restProps$color = restProps.color,
      color = _restProps$color === void 0 ? theme.header.logo.color : _restProps$color;
  return /*#__PURE__*/_jsx(IconButton, _objectSpread({
    icon: /*#__PURE__*/_jsx(Logo, {
      $styles: {
        width: theme.header.logo.width,
        height: theme.header.logo.height,
        color: color,
        transition: 'color 250ms ease'
      }
    }),
    label: "Miro Logo",
    href: href,
    className: className,
    title: "Go to the main page"
  }, restProps));
};

var HeaderLogo = styled(HeaderLogoBase).withConfig({
  displayName: "HeaderLogo",
  componentId: "sc-mdnph2-0"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    width: theme.header.logo.width,
    height: theme.header.logo.height,
    position: 'relative',
    top: theme.header.logo.offset.top
  });
});
export default HeaderLogo;